import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import Item from '~/stores/models/Item'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionProcessingCompanyUpdates',
  setup(__props) {


const collections = useCollectionsStore()

const validator = (item: Item) => {
  return item.item_attributes.reporting ? '' : 'Not accepting updates'
}


return (_ctx: any,_cache: any) => {
  const _component_CollectionProcessingDialog = _resolveComponent("CollectionProcessingDialog")!

  return (_openBlock(), _createBlock(_component_CollectionProcessingDialog, { validator: validator }, {
    options: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("p", null, "A request for a company update will be sent to the companies listed below.", -1)
    ]))]),
    results: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collections).processResult, (result) => {
        return (_openBlock(), _createElementBlock("p", { key: result }, " • " + _toDisplayString(result), 1))
      }), 128))
    ]),
    _: 1
  }))
}
}

})